<template>
  <div style="height:100%;">
    <zj-layout-container>
      <zj-layout-header style="padding:0rem 0px 0px 0px;">
        <div class="zj-button-bar">
          <el-button size="mini" @click="onAdd">添 加</el-button>
        </div>
      </zj-layout-header>
      <zj-layout-main style="padding:0rem 0px 0px 0px;">
        <el-table
          class="table-default"
          height="100%"
          :data="tableData"
          ref="multipleTable"
          @selection-change="selectionChange"
          border
          style="width: 100%"
        >
          <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
          <el-table-column prop="ResourceName" label="通讯资源名称" align="center"></el-table-column>
          <el-table-column prop="Address" label="地址" align="center"></el-table-column>
          <el-table-column prop="Contact" label="负责人" align="center"></el-table-column>
          <el-table-column prop="Phone" label="联系电话" align="center"></el-table-column>
          <el-table-column label="操作" width="60" align="center">
            <template slot-scope="scope">
              <el-button @click="deleteClick(scope.$index,scope.row)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </zj-layout-main>
    </zj-layout-container>

    <el-dialog v-dialogDrag title="通讯资源" :visible.sync="dialogTableVisible">
      <zj-layout-container style="height: 60rem;">
        <zj-layout-main style="padding:0rem 0rem;">
          <el-table
            ref="multipleTable"
            :data="DialogtableData"
            @selection-change="handleSelectionChange"
            border
            style="width:100%"
            height="100%"
          >
            <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
            <el-table-column prop="ResourceName" label="通讯资源名称" align="center"></el-table-column>
            <el-table-column prop="Address" label="地址" align="center"></el-table-column>
            <el-table-column prop="Contact" label="负责人" align="center"></el-table-column>
            <el-table-column prop="Phone" label="联系电话" align="center"></el-table-column>
            <el-table-column type="selection" width="55" align="center"></el-table-column>
          </el-table>
        </zj-layout-main>
        <zj-layout-footer style="text-align: center;">
          <el-button @click="onBack()">取消</el-button>
          <el-button @click="onOk()">确定</el-button>
        </zj-layout-footer>
      </zj-layout-container>
    </el-dialog>
  </div>
</template>
<script>
import MyApis from "../../../apis";
export default {
  name: "ZjComponentCommunicationDetail",
  controller: "UI",
  action: "ComponentCommunicationDetail",
  props: {
    PlanTaskId: String,
    TaskSubTypeId: String
  },
  data() {
    return {
      dialogTableVisible: false,
      multipleSelection: [],
      DialogtableData: [],
      tableData: [] //用来作为receivers
    };
  },
  created: function() {
    let searchInfo = {
      PageSize: 100,
      PageIndex: 1,
      TotalCount: 0,
      StartNumber: 0,
      EndNumber: 0
    };
    this.showLoading('加载中...');
    new MyApis.CommunicationresourcesApi()
      .GetPageContentByConditions(searchInfo)
      .then(r => {
        r = r.data.Data;
        this.DialogtableData = r.PageContents;
        this.hideLoading();
        this.search();
      })
      .catch(e => {
        console.error(e);
        this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        this.hideLoading();
      });
  },
  methods: {
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox"
      });
    },
    showLoading(text) {
      this.$emit('loading', text);
    },
    hideLoading() {
      this.$emit('loadingFinish');
    },
    deleteClick(index, row) {
      this.tableData.splice(this.tableData.indexOf(row), 1);
    },
    onAdd() {
      this.dialogTableVisible = true;
      this.multipleSelection = this.tableData;
      this.toggleSelection(this.multipleSelection);
    },
    onBack() {
      this.dialogTableVisible = false;
    },
    onOk() {
      this.tableData = this.multipleSelection;
      this.dialogTableVisible = false;
    },
    toggleSelection(rows) {
      this.$refs.multipleTable.clearSelection();
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    search() {
      let PlanTaskId = this.$props.PlanTaskId;
      //let TaskSubTypeId=this.$props.TaskSubTypeId;
      if (PlanTaskId != null && PlanTaskId != "") {
        let searchInfo = {
          PlanTaskId: PlanTaskId,
          TaskSubTypeId: "EmergencyTaskType.Resource.Communication",
          PageSize: 20,
          PageIndex: 1,
          TotalCount: 0,
          StartNumber: 0,
          EndNumber: 0
        };
        this.showLoading('加载中...');
        new MyApis.PlantaskreceiverApi()
          .GetTaskCommunicationResourcesList(searchInfo)
          .then(r => {
            var data = r.data.Data;
            if (data.length>0) {
                this.tableData=data;
            }
            this.hideLoading();
          })
          .catch(e => {
            console.error(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
            this.hideLoading();
          });
      }
    },
    Gettaskreceiver() {
      //todo 组织setting和receivers
      var receivers = [];
      var tasksett = {};
      tasksett.OrgId = this.user.Departments[0].OrgId;
      //tasksett.SettingId = utils.uuid();
      tasksett.PlanTaskId = this.PlanTaskId;
      tasksett.SettingContent = "通讯资源配置";
      tasksett.TaskSubTypeId = this.TaskSubTypeId;
      for (var i = 0; i < this.tableData.length; i++) {
        var receobj = {};
        receobj.OrgId = this.user.Departments[0].OrgId;
        //receobj.TaskSettinId = tasksett.SettingId;
        receobj.TaskSubTypeId = this.TaskSubTypeId;
        receobj.ReceiverId = this.tableData[i].ResourcesId;
        receivers.push(receobj);
      }
      return { TaskSettingDTO: tasksett, TaskReceiverDTO: receivers };
    }
  }
};
</script>